module.exports = __webpack_public_path__ + "img/icaon_tixian_01@2x.54eb87ac.png";